import { format, formatDistanceToNowStrict } from 'date-fns';

export const EM_DASH = '—';

export function formatDate(value?: string | null) {
  if (!value) return EM_DASH;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? EM_DASH : format(parsed, 'MMM d, yyyy');
}

export function formatDateTime(value?: string | null) {
  if (!value) return EM_DASH;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? EM_DASH : format(parsed, 'MMM d, yyyy HH:mm');
}

export function formatRelative(value?: string | null) {
  if (!value) return EM_DASH;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return EM_DASH;
  return `${formatDistanceToNowStrict(parsed)} ago`;
}

export function formatNumber(value: number | undefined | null) {
  if (value === undefined || value === null) return EM_DASH;
  return new Intl.NumberFormat().format(value);
}

export function formatBytes(bytes: number | undefined | null) {
  if (!bytes) return '0 B';
  const units = ['B', 'kB', 'MB', 'GB', 'TB'];
  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / 1024 ** exponent;
  return `${value.toFixed(value >= 10 || exponent === 0 ? 0 : 1)} ${units[exponent]}`;
}

/** "3 days", "1 day", "today" — used for how long a case has sat in its stage. */
export function formatDayCount(days: number) {
  if (days <= 0) return 'today';
  return days === 1 ? '1 day' : `${days} days`;
}
